module.exports = __webpack_public_path__ + "img/eagle-full.9477a6f8.png";